import React, { Component } from 'react';
import Nav from '../components/Nav';
import GetTheApp from '../components/GetTheApp';
import Footer from '../components/Footer';
import { Link } from 'react-router';

class BuildingManagers extends Component {

  constructor(props) {
    super(props);

    this.renderPoint = this.renderPoint.bind(this);
  }

  renderPoint(title, description, index) {
    return(
      <div className="row space-4" key={index}>
        <div className="col-sm-12 col-md-12">
          <h3 className="space-2">{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    );
  }

  render() {

    const points = [
      {
        "title": "Authenticated Entry",
        "description": "With traditional intercom entry, unauthorized entrants can get into almost any building by dialing multiple residences- with Tiny Doorman, visitors are authenticated with unique digital keys, so users know who is entering the building and when."
      },
      {
        "title": "Digital Keys",
        "description": "Residents aren't always available by phone and some give out physical keys to cleaners, dog walkers, friends, visitors, service people, and anyone else who needs temporary access.  These keys can’t be tracked, and can be used perpetually until the building locks are changed.  Tiny Doorman makes it easy to give controlled, digital access instead, which can be revoked at any time."
      },
      {
        "title": "Trackable Entry",
        "description": "When a resident buzzes someone up over the intercom or provides a front door key, entry by the visitor is anonymous and untracked.  When a resident installs Tiny Doorman, they'll have a record of who entered and when."
      },
      {
        "title": "Headache-Free Entry",
        "description": "Residents miss the intercom call for package deliveries (or can’t tell who is at the door), accidentally lock out friends (or themselves), and otherwise are constantly inconvenienced by the intercom.  Packages and food deliverers are often left stranded at the intercom, which encourages residents to let in people waiting at the door, reducing overall building security."
      }
    ];

    return (
      <div className="BuildingManagers">
        <div className="background-blue clearfix">
          <Nav />
        </div>

        <div className="page-container-responsive">
          <div className="row space-top-5 space-4 space-top-sm-4">
            <div className="col-sm-12 col-md-12">
              <h3 className="space-4">Your current intercom system has one job: let the right people in, and keep the wrong people out. But it doesn’t always do a very good job at that.  Upgrade it with an intelligence service that turns it into a high-functioning Tiny Doorman- all without any cost or changes to your current intercom service.</h3>
              <h3 className="space-4">Tiny Doorman is an app available to your residents for $5/month.  All they need to do is work with you to change the phone number in their intercom listing.  Once installed, residents can grant secure, revocable, virtual keys for the front door, making your whole building more secure.  Fewer front door keys will be distributed and copied, it will be harder for unauthorized visitors to gain entry, guest access will be tracked, and guest access can expire or be revoked.</h3>
              <hr />
            </div>
          </div>

          <div className="row space-4">
            <div className="col-sm-12 col-md-12">
              <h2>How does Tiny Doorman make your current intercom experience better?</h2>
            </div>
          </div>

          {points.map((point, index) => {
            return(
              this.renderPoint(point.title, point.description, index)
            )
          })}

          <div className="row space-4">
            <div className="col-sm-12 col-md-12">
              <hr />
            </div>
          </div>

          <div className="row space-4">
            <div className="col-sm-12 col-md-12">
              <h2 className="space-4">Is Tiny Doorman safe?</h2>
              <p className="space-3">Current intercoms are inherently insecure- visitor authentication is done only by audio, where it is difficult to determine identity.   As such, it’s easy to gain access by trying several listings and claiming to be making a delivery, and many residents buzz in anyone who calls because it is so difficult to verify identity.</p>
              <p className="space-3">Physical keys, likewise, are insecure.  They can be copied and distributed without your permission, and entries using physical keys are not tracked or recorded.</p>
              <p className="space-4">Residents often miss the intercom call for package deliveries, can’t tell who is at the door, accidentally lock out friends (or themselves), and are otherwise are constantly inconvenienced by the intercom. By using Tiny Doorman, users don't need to answer their phone- the visitor can use the virtual key to let themselves in, and the user will be notified that they arrived.</p>
              <hr />
            </div>
          </div>

          <div className="row space-5 space-sm-4">
            <div className="col-sm-12 col-md-12">
              <h2 className="space-4">More questions?</h2>
              <p>Check out the <Link to="/faq">FAQ</Link>, email <a href="mailto:support@tinydoorman.com">support</a>, or call (628) 227-5867</p>
            </div>
          </div>

        </div>

        <GetTheApp />
        <Footer />
      </div>
    );
  }
}

export default BuildingManagers;



/** WEBPACK FOOTER **
 ** ./src/pages/BuildingManagers.js
 **/